<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: CustomSelect                                          |
| Section: atoms                                                   |
| Purpose: Styled native select wrapper with two-way binding.      |
+------------------------------------------------------------------+
-->
<template>
    <div :class="['custom-select-wrapper', wrapperClass]">
        <select v-model="selectedValue" @change="onChange" class="custom-select">
            <option v-for="option in options" :key="option.value" :value="option.value">
                {{ option.label }}
            </option>
        </select>
        <img class="custom-caret" src="@/assets/icons/caret-down.svg" alt="Dropdown indicator" />
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            required: true,
        },
        wrapperClass: {
            type: String,
            default: '', // Default to no additional class
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            selectedValue: this.modelValue,
        };
    },
    watch: {
        modelValue(newValue) {
            this.selectedValue = newValue;
        },
        selectedValue(newValue) {
            this.$emit('update:modelValue', newValue);
        },
    },
    methods: {
        onChange() {
            this.$emit('update:modelValue', this.selectedValue);
        },
    },
};
</script>

<style scoped>
.custom-select-wrapper {
    position: relative;
    display: inline-block;
    width: 84px;
    /* Default width */
}

.custom-select-wrapper.custom-select--96px {
    width: 72px;
}

.custom-select-wrapper.custom-select--144px {
    width: 144px;
}

.custom-select {
    width: 100%;
    padding: 12px 16px;
    appearance: none;
    background-color: var(--brand-bg-1);
    border: 2px solid #EEE;
    border-radius: 4px;
    font-size: 16px;
    color: var(--brand-text-dark);
    cursor: pointer;
    transition: var(--transition-ease);
}

.custom-select:hover,
.custom-select:focus {
    border: 2px solid var(--brand-color-1);
}

.custom-caret {
    position: absolute;
    top: 50%;
    right: 16px;
    pointer-events: none;
    transform: translateY(-50%);
}
</style>
